import {otsBaseApi} from "../../ots-api";
import {NotificationTemplate, NotificationTemplatePayload} from "../../../model/notification-template";

const ALL_TAG_TYPES = [
  "NotificationTemplates",
  "ObjectObjectChangeLogs",
] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

const notificationTemplateApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotificationTemplates: builder.query<
      NotificationTemplate[],
      void
    >({
      query: () => ({
        url: `/notification-templates/all`,
        method: 'GET',
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "NotificationTemplates", id} as const)),
            {type: "NotificationTemplates", id: "LIST"}
          ];
        } else {
          return [{type: "NotificationTemplates", id: "LIST"}];
        }
      },
    }),
    getNotificationTemplate: builder.query<NotificationTemplate, string>({
      query: (id) => ({
        url: `/notification-templates/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "NotificationTemplates", id}]
    }),
    createNotificationTemplate: builder.mutation<NotificationTemplate, NotificationTemplatePayload>({
      query: (mapping) => ({
        url: "/notification-templates",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "NotificationTemplates", id: "LIST"}]
    }),
    updateNotificationTemplate: builder.mutation<NotificationTemplate, NotificationTemplatePayload>({
      query: (mapping) => ({
        url: "/notification-templates",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "NotificationTemplates", id},
        {type: "ObjectObjectChangeLogs", id}
      ]
    }),
    deleteNotificationTemplate: builder.mutation<void, Partial<NotificationTemplate>>({
      query: (mapping) => ({
        url: "/notification-templates",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "NotificationTemplates", id}]
    }),
  })
});

export const {
  useGetAllNotificationTemplatesQuery,
  useGetNotificationTemplateQuery,
  useCreateNotificationTemplateMutation,
  useUpdateNotificationTemplateMutation,
  useDeleteNotificationTemplateMutation,
} = notificationTemplateApi;
